export const getWaterfallBreakpoint = (captableId: number) => `/api/cap-tables/${captableId}/all-breakpoints`;
export const getCaptablebyCompany = (companyId: number) => `/api/companies/${companyId}/cap-tables`;
export const findCaptable = (captableId: number) => `/api/cap-tables/${captableId}`;
export const toggleWaterfallVisibility = (captableId: number) =>
  `/api/cap-tables/${captableId}/toggle-waterfall-visibility`;

export default {
  getWaterfallBreakpoint,
  getCaptablebyCompany,
  findCaptable,
  toggleWaterfallVisibility,
};
